import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeHexagon extends Shape {
    width = 200;
    height = 182;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 2);
        canv.ctx.lineTo(x + width / 4, y);
        canv.ctx.lineTo(x + (width * 3) / 4, y);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + (width * 3) / 4, y + height);
        canv.ctx.lineTo(x + width / 4, y + height);
        canv.ctx.lineTo(x, y + height / 2);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M6.90674 1.53599L1.24305 12.3485C1.09083 12.6391 1.09083 12.9859 1.24305 13.2765L6.90674 24.089C7.07935 24.4185 7.42059 24.625 7.79257 24.625H20.6697C21.0285 24.625 21.3599 24.4327 21.5379 24.1211L27.7165 13.3086C27.8922 13.0012 27.8922 12.6238 27.7165 12.3164L21.5379 1.50386C21.3599 1.19229 21.0285 1 20.6697 1H7.79257C7.42059 1 7.07935 1.20648 6.90674 1.53599Z"/>
            </svg>
        `;
    }
}
